import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#FF6B00]/30 rounded-2xl p-5 flex flex-col gap-3" data-id="element-333">
      <div className="flex items-center gap-3" data-id="element-334">
        <div className="w-10 h-10 rounded-full bg-[#FF6B00]/20 border border-[#FF6B00]/40 flex items-center justify-center text-[#FF6B00] font-black text-xs flex-shrink-0" data-id="element-335">
          {initials}
        </div>
        <div data-id="element-336">
          <div className="text-[#FF6B00] text-xs" data-id="element-337">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-338">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-339">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-340">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-341">
      <div className="max-w-5xl mx-auto" data-id="element-342">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-343">
          Lo que dicen los profes
          <span className="text-[#FF6B00]" data-id="element-344"> que ya lo usan:</span>
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-345">
          +300 profesores de folklore de todo el país ya tienen su MegaPack
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-346">
          <TestimonialCard initials="MR" stars={5} quote="Compré un domingo a la noche. El lunes tenía todo el año organizado. Las 24 clases modelo del Tomo 1 son exactamente lo que necesitaba para el jardín." name="María Rosa" location="Buenos Aires" level="Profesora de Escuela Primaria" data-id="element-347" />
          <TestimonialCard initials="JC" stars={5} quote="El sistema del Tomo 3 de estilización me cambió todo. El primer mes, tres alumnos lograron la zamba completa que llevaban meses sin poder hacer. Los 120 guiones de clase hacen la diferencia." name="Jorge C." location="Rosario" level="Profesor en Academia Privada" data-id="element-348" />
          <TestimonialCard initials="SV" stars={5} quote="El Tomo 4 de Malambo es único en el mercado. Mis alumnos ahora zapatan de manera diferente. Tienen mudanzas reales, progresión técnica y un malambo de 3 minutos. Antes eso me llevaba un año. Ahora, 4 meses." name="Sofía V." location="Córdoba" level="Profesora Independiente" data-id="element-349" />
          <TestimonialCard initials="FL" stars={5} quote="El sistema de niveles con criterios objetivos eliminó las preguntas de '¿cuándo paso al siguiente nivel?'. Ahora el alumno lo mide solo con la rúbrica. Y paga más contento porque ve que avanza." name="Fernando L." location="Tucumán" level="Profesor Particular y Academia" data-id="element-350" />
          <TestimonialCard initials="LP" stars={5} quote="Mi tasa de retención pasó del 40% al 80%. Sin cambiar técnicamente lo que doy. Solo aplicando el sistema de fidelización del Tomo 5 y el Folklore Pro Elite. En 6 meses llené todos mis horarios." name="Laura P." location="Mendoza" level="Profesora de Folklore y Danzas Nativas" data-id="element-351" />
          <TestimonialCard initials="VT" stars={5} quote="Ahora entrego el Kit de Inscripción Profesional en la primera clase y mando el calendario de contenidos cada semana. Los directivos me preguntaron si era una institución formal. Les dije que sí." name="Valeria T." location="Santa Fe" level="Profesora de Folklore" data-id="element-352" />
          <TestimonialCard initials="AR" stars={5} quote="El Tomo 5 de adultos mayores es lo que nunca encontré en ningún lado. El checklist de seguridad, las danzas adaptadas, la gestión emocional. Mis alumnos de 75 años bailan el Pericón con pañuelo y lloran de emoción." name="Ana R." location="Salta" level="Profesora en Centro de Jubilados" data-id="element-353" />
        </div>
      </div>
    </section>;
}